import { useContext } from "react";
import { Link } from "react-router-dom";
import { LoaderCard } from "../../../common/Loader";
import { getDistrictSummary, getPercentage, translate, translateNumber, translatePercentage } from "../../../../helper";
import { ASSET_HOST_BASE_URL, otherParty } from "../../../../config";
import LangContext from "../../../../contexts/LangContext";

import "./index.css";

const DistrictSummary = (props) => {
  const { lang } = useContext(LangContext);
  const { tab, fetched, province, data, parties } = props;

  const districtData = data.map((districtData) => {
    return getDistrictSummary(districtData);
  });

  return (
    <section id="sh-district-summary" className="sh-summary-section">
      <div className="container">
        <div className="container-fluid-removed card-removed sh-card-summary">
          <div className="row" style={{ opacity: fetched ? "1" : 0.5 }}>
            <div className="col-md-12">
              <h3 className="text-center">{translate("district", lang) + " " + translate("details", lang)}</h3>
              <br />
            </div>
            {province.districts.map((dist, i) => {
              const dData = districtData.find((d) => d.id === dist.id);
              const ern = dist.regions.filter((r) => r.rtype === "federal").length;
              return (
                <div className="col-md-12" key={i}>
                  <div className="sh-widget-card card">
                    {!fetched && <LoaderCard />}
                    <h3>
                      <Link to={"/result/" + province.id + "/" + dist.id + "?type=" + tab + "&lang=" + lang}>{dist["name_" + lang]}</Link>
                      <span className="total-er pull-right">
                        {translate("total_ERN", lang)}: {translateNumber(dData ? dData.ern : ern, lang)}
                      </span>
                    </h3>
                    <div className="row">
                      <div className="col-md-6 col-sm-12 sh-district-card">
                        <h4 className="text-center">{translate("win", lang)}</h4>
                        <div className="sh-card-win card">
                          {dData &&
                            dData.win.map((w, i) => {
                              const party = parties.find((par) => par.code === w.party) || otherParty;
                              return (
                                <div key={i}>
                                  <label className="sh-progress-bar-label" htmlFor="">
                                    <img
                                      src={ASSET_HOST_BASE_URL + "/images/parties/" + party.code.toUpperCase() + ".png"}
                                      alt={party.code.toUpperCase()}
                                      onError={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
                                      }}
                                      className="pull-left sh-party-symbol"
                                      width="20px"
                                      height="20px"
                                    />
                                    <Link to={"/candidates" + (w.party === "O" ? "" : "/" + w.party)}>{party["short_name_" + lang] ? party["short_name_" + lang] : party["name_" + lang]}</Link>
                                  </label>
                                  <span className="pull-right data">{translateNumber(w.win, lang)}</span>
                                  <div className="progress">
                                    <div className="progress-bar" role="progressbar" style={{ width: getPercentage(w.win, dData.totalWin), backgroundColor: party.color, opacity: 1 }}>
                                      {translatePercentage(w.win, dData.totalWin, lang)}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12 sh-district-card">
                        <h4 className="text-center">{translate("lead", lang)}</h4>
                        <div className="sh-card-lead card">
                          {dData &&
                            dData.lead.map((l, i) => {
                              const party = parties.find((par) => par.code === l.party) || otherParty;
                              return (
                                <div key={i}>
                                  <label className="sh-progress-bar-label" htmlFor="">
                                    <img
                                      src={ASSET_HOST_BASE_URL + "/images/parties/" + party.code.toUpperCase() + ".png"}
                                      alt={party.code.toUpperCase()}
                                      onError={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src = ASSET_HOST_BASE_URL + "/images/parties/O.png";
                                      }}
                                      className="pull-left sh-party-symbol"
                                      width="20px"
                                      height="20px"
                                    />
                                    <Link to={"/candidates" + (l.party === "O" ? "" : "/" + l.party)}>{party["short_name_" + lang] ? party["short_name_" + lang] : party["name_" + lang]}</Link>
                                  </label>
                                  <span className="pull-right data">{translateNumber(l.lead, lang)}</span>
                                  <div className="progress">
                                    <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{ width: getPercentage(l.lead, dData.totalLead), backgroundColor: party.color, opacity: 1 }}>
                                      {translatePercentage(l.lead, dData.totalLead, lang)}
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default DistrictSummary;
